module.exports = __webpack_public_path__ + "img/22_6.53f503de.png";